import * as React from "react"

function SvgDownloadBottom(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 22 22"
      {...props}
    >
      <path
        d="M20.821 16.552v1.708a2.563 2.563 0 01-2.561 2.561H3.74a2.561 2.561 0 01-2.56-2.561v-1.708m9.82-.098V1.179m6.25 9.025L11 16.454l-6.25-6.25"
        fill="none"
        fillRule="evenodd"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.25}
      />
    </svg>
  )
}

export default SvgDownloadBottom
